import React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import "./styles/style.scss";

function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;
